let isShowNsgBox = false;

export default {
  MUTATE_LOGIN(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.login = payload;
  },
  
  MUTATE_PROFILE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.profile = payload;
  },

  MUTATE_SUBSCRIBE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.subscribe = payload;
  },
  
  MUTATE_SNACKBAR(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.snackBar = payload;
  },

  SET_AUTH_DATA(st, { accessToken, refreshToken }) {
    st.accessToken = accessToken;
    st.refreshToken = refreshToken;
    localStorage.setItem('dc-access', accessToken);
    localStorage.setItem('dc-refresh', refreshToken);
  },

  // 清除認證資料
  CLEAR_AUTH_DATA(st) {
    st.accessToken = null;
    st.refreshToken = null;
    st.profile = null
    st.login = false
    localStorage.removeItem('dc-access');
    localStorage.removeItem('dc-refresh');
  },

  // (僅) 更新 Access Token (用於刷新)
  SET_ACCESS_TOKEN(st, accessToken) {
    st.accessToken = accessToken;
    localStorage.setItem('dc-access', accessToken);
  },

  UPDATE_MESSAGE_BOX(st, payload) {
    // eslint-disable-next-line no-param-reassign
    if(isShowNsgBox) return;
    isShowNsgBox = true;
    st.msgBox = payload;

    setTimeout(() => {
      st.msgBox.active = false;
      isShowNsgBox = false;
    }, 3000);
  },

  SET_RWD_TYPE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.rwdType = payload;
  },
};
